class Helper {
    static FormatUnixTimestamp(time) {
        time = (typeof time !== "number") ? parseInt(time) : time;
        // console.log(time);
        let m = new Date(time * 1000);
        //console.log(m);


        let dateString =
            m.getFullYear() + "-" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "-" +
            ("0" + m.getDate()).slice(-2) + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2);
        //console.log(dateString);

        let returnValue = (time === 0) ? "-" : dateString;

        return returnValue;
    }

    static ConvertMtrainloadDisplay(percentage) {

        const MAX = 270;

        if (percentage === 100) {
            return 0;
        } else if (percentage > 47.5 && percentage < 100) {
            // Optional: clamp the input to ensure it stays within bounds
            const clampedX = Math.max(47.5, Math.min(100, percentage));

            const x1 = 47.5, y1 = 110;
            const x2 = 100.0, y2 = 0;

            // Linear interpolation formula: y = y1 + (x - x1) * (y2 - y1) / (x2 - x1)
            return Math.floor(y1 + (clampedX - x1) * (y2 - y1) / (x2 - x1));
        } else if (percentage >= 18 && percentage <= 47.5) {
            // Clamp the input to ensure it stays within bounds
            const clampedX = Math.max(18, Math.min(47.5, percentage));

            const x1 = 18, y1 = 240;
            const x2 = 47.5, y2 = 110;

            // Linear interpolation formula: y = y1 + (x - x1) * (y2 - y1) / (x2 - x1)
            return Math.floor(y1 + (clampedX - x1) * (y2 - y1) / (x2 - x1));
        } else if (percentage > 0 && percentage < 18) {
            // Clamp the input to ensure it stays within bounds
            const clampedX = Math.max(0, Math.min(18, percentage));

            const x1 = 0, y1 = MAX;
            const x2 = 18, y2 = 240;

            // Linear interpolation formula: y = y1 + (x - x1) * (y2 - y1) / (x2 - x1)
            return Math.floor(y1 + (clampedX - x1) * (y2 - y1) / (x2 - x1));
        } else if (percentage === 0) {
            return "--";
        } else {
            return 0
        }
    }
}



export default Helper;